'use client';

// eslint-disable-next-line @alltrails/custom/client-navigation
import { useParams } from 'next/navigation';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import type { Locale } from '@alltrails/types/Locale';
import { getLanguageRegionCodeFromLocale } from '../utils/languageTypeModifiers';
import useRouter from './useRouter';

type Params = {
  locale: Locale;
};

export function useLanguageRegionCode(): LanguageRegionCode {
  const router = useRouter();
  const params = useParams<Params>();

  const locale = router ? (router.locale as Locale) : params?.locale;

  return getLanguageRegionCodeFromLocale(locale) || 'en-US';
}
